import React from 'react'
import ProgramsDashboard from '../../../components/Project/Programs/ProgramsDashboard'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { withRouter } from 'react-router-dom'
import { strVal } from '../../../modules/Utils'
import ProjectApi from '../../../api/Corporates/Projects'
import useFetchObject from '../../../elements/Hooks/useFetchObject'

const api = new ProjectApi()

function ProgramsDashboardCont(props) {
  const key = strVal(props, 'match.params.key')
  const { object: program, fetching: fetchingProgram, fetch: fetchProgram } = useFetchObject(() =>
    api.get(key)
  )
  const { list, fetching, fetch } = useFetchList(() => api.listByParent(key))
  return (
    <ProgramsDashboard
      {...{
        list,
        fetching,
        fetch,
        program,
        fetchingProgram,
        fetchProgram,
      }}
    />
  )
}

export default withRouter(ProgramsDashboardCont)
